import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../store/authStore';
import { useAuthInitialized } from './AuthProvider';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const { initialized } = useAuthInitialized();

  // Wait for keycloak.init() to finish before deciding. Redirecting to /login
  // first strips the ?code= callback param and breaks the PKCE exchange.
  if (!initialized || isLoading) {
    return (
      <div className="loading-spinner">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return (
      <div className="loading-spinner">
        <div className="spinner" />
      </div>
    );
  }

  if (user.role !== 'admin') {
    return (
      <div className="container">
        <div className="panel" style={{ maxWidth: '560px', margin: '4rem auto' }}>
          <h2>Admin Access Required</h2>
          <p className="page-subtitle">
            Your account does not have administrator privileges on this store.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
